






































import { Component, Vue } from "vue-property-decorator";
import Headings from "./Styleguide/Headings.vue";
import Icons from "./Styleguide/Icons.vue";
import Buttons from "./Styleguide/Buttons.vue";
import Badges from "./Styleguide/Badges.vue";
import FormControls from "./Styleguide/FormControls.vue";
import Modals from "./Styleguide/Modals.vue";
import Tables from "./Styleguide/Tables.vue";
import CustomComponents from "./Styleguide/CustomComponents.vue";

@Component({
  components: {
    Headings,
    Icons,
    Buttons,
    Badges,
    FormControls,
    Modals,
    Tables,
    CustomComponents,
  },
})
export default class Styleguide extends Vue {}
